/*
  NUVA — Interacciones del shell de "Mi negocio NUVA"
  ------------------------------------------------------------------
  - Menú móvil: abre/cierra con botón, Escape y toque fuera; mantiene
    el foco dentro mientras está abierto y lo devuelve al botón que lo abrió.
  - Menú de cuenta del encabezado: mismo comportamiento (Escape, clic fuera).
  - Pestañas compartidas del portal ([data-np-tabs]): flechas, Inicio y Fin.
  Nada aquí decide qué contenido se muestra: eso ya se resolvió en el
  servidor (Liquid) antes de enviar el HTML.
*/
(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function visibles(root) {
    return Array.prototype.slice.call(root.querySelectorAll(FOCUSABLE)).filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0;
    });
  }

  function initDrawer(app) {
    var drawer = app.querySelector('[data-nuva-app-drawer]');
    var panel = app.querySelector('[data-nuva-app-drawer-panel]');
    var openBtn = app.querySelector('[data-nuva-app-menu-open]');
    if (!drawer || !panel || !openBtn) return;
    var closeEls = drawer.querySelectorAll('[data-nuva-app-menu-close]');
    var lastFocus = null;
    var closeTimer = null;
    var desktop = window.matchMedia('(min-width: 900px)');

    function onKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
        return;
      }
      if (e.key !== 'Tab') return;
      var items = visibles(panel);
      if (!items.length) { e.preventDefault(); panel.focus(); return; }
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function open() {
      if (drawer.classList.contains('is-open')) return;
      window.clearTimeout(closeTimer);
      lastFocus = document.activeElement;
      drawer.hidden = false;
      void drawer.offsetWidth; // aplica el estado inicial antes de animar
      drawer.classList.add('is-open');
      openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('nuva-app-locked');
      document.addEventListener('keydown', onKeydown);
      var current = panel.querySelector('[aria-current="page"]');
      (current || visibles(panel)[0] || panel).focus();
    }

    function close(opts) {
      if (!drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('nuva-app-locked');
      document.removeEventListener('keydown', onKeydown);
      closeTimer = window.setTimeout(function () { drawer.hidden = true; }, 260);
      if (!(opts && opts.noFocus)) (lastFocus && lastFocus.focus ? lastFocus : openBtn).focus();
    }

    openBtn.addEventListener('click', open);
    Array.prototype.forEach.call(closeEls, function (el) { el.addEventListener('click', function () { close(); }); });
    var onChange = function (e) { if (e.matches) close({ noFocus: true }); };
    if (desktop.addEventListener) desktop.addEventListener('change', onChange);
    else if (desktop.addListener) desktop.addListener(onChange);
  }

  function initAccount(app) {
    var account = app.querySelector('[data-nuva-app-account]');
    var toggle = app.querySelector('[data-nuva-app-account-toggle]');
    var menu = account && account.querySelector('.nuva-app__account-menu');
    if (!account || !toggle || !menu) return;

    function set(openState, returnFocus) {
      menu.hidden = !openState;
      account.classList.toggle('is-open', openState);
      toggle.setAttribute('aria-expanded', openState ? 'true' : 'false');
      if (!openState && returnFocus) toggle.focus();
    }
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      set(menu.hidden, false);
      if (!menu.hidden) { var first = menu.querySelector('a'); if (first) first.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (!menu.hidden && !account.contains(e.target)) set(false, false);
    });
    account.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) { e.preventDefault(); set(false, true); }
    });
    account.addEventListener('focusout', function (e) {
      if (!menu.hidden && e.relatedTarget && !account.contains(e.relatedTarget)) set(false, false);
    });
  }

  /* Pestañas accesibles del portal: role="tablist" con botones role="tab" y paneles role="tabpanel". */
  function initTabs(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-np-tabs]'), function (tablist) {
      var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));
      if (!tabs.length) return;
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t, false); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = tabs[(i + 1) % tabs.length];
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = tabs[(i - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') n = tabs[0];
          else if (e.key === 'End') n = tabs[tabs.length - 1];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
      tablist.npSelect = function (id) {
        var t = tabs.filter(function (x) { return x.getAttribute('aria-controls') === id; })[0];
        if (t) select(t, false);
      };
    });
  }

  function start() {
    var app = document.querySelector('[data-nuva-app]');
    if (!app) return;
    initDrawer(app);
    initAccount(app);
    initTabs(app);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
